var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLinkToEdit)?_c('div',{staticClass:"link-details"},[_c('LinkDetails',{attrs:{"link":_vm.linkToEdit}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }